import React from 'react';

import imageOverlay from '../../assets/images/video-overlay.svg';

export const OverlayVideo = () => {
  return (
    <div className={'media-overlay'} style={{ backgroundImage: `url(${imageOverlay})`}}></div>
  );
};
